import React from 'react';
import { Section } from './ui/Section';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Check } from 'lucide-react';
export function WhatYouGet() {
  const items = ['Guía visual (≈35 páginas/slides) — lectura en 20 min', 'Técnica Muralla Mental paso a paso', 'Protocolo 15 min de Silencio Radical', 'Ejercicio Inventario del Yo (5 min)', 'Checklist semanal para mantenerlo'];
  return <Section data-id="element-158">
      <FadeIn data-id="element-159">
        <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-8" data-id="element-160">
          Qué recibes exactamente
        </h2>
      </FadeIn>

      <StaggerContainer className="space-y-4 mb-8" data-id="element-161">
        {items.map((item, index) => <StaggerItem key={index} className="flex items-start gap-3" data-id="element-162">
            <Check className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-163" />
            <p className="text-charcoal text-base md:text-lg" data-id="element-164">{item}</p>
          </StaggerItem>)}
      </StaggerContainer>

      <FadeIn data-id="element-165">
        <p className="text-sm text-gray italic border-t border-border pt-6" data-id="element-166">
          No te promete una vida perfecta. Te da un plan para recuperar calma
          cuando la pierdes.
        </p>
      </FadeIn>
    </Section>;
}